import { Input } from "@/components/ui/input";

const show = (v) => {
  if (v === null || v === undefined || v === "") return "";
  const [int, dec] = String(v).split(".");
  const n = int.replace(/\D/g, "");
  const body = n === "" ? (dec !== undefined ? "0" : "") : Number(n).toLocaleString("id-ID");
  return dec !== undefined ? `${body},${dec}` : body;
};

const parse = (s) => {
  const [int, ...rest] = s.replace(/[^\d,]/g, "").split(",");
  return rest.length ? `${int}.${rest.join("")}` : int;
};

// Pasted text: last separator is decimal if both exist, or a lone dot followed by 1-2 digits
const normPaste = (t) => {
  const s = t.replace(/[^\d.,]/g, "");
  const last = Math.max(s.lastIndexOf("."), s.lastIndexOf(","));
  const both = s.includes(".") && s.includes(",");
  const loneDot = !s.includes(",") && (s.match(/\./g) || []).length === 1 && /\.\d{1,2}$/.test(s);
  if (both || loneDot) return s.slice(0, last).replace(/[.,]/g, "") + "," + s.slice(last + 1);
  return s;
};

export const NumInput = ({ value, onChange, ...props }) => {
  const emit = (raw) => onChange({ target: { value: parse(raw) } });
  const handle = (e) => {
    let raw = e.target.value;
    const pos = e.target.selectionStart;
    if (e.nativeEvent?.data === "." && pos > 0 && raw[pos - 1] === "." && !raw.includes(",")) raw = raw.slice(0, pos - 1) + "," + raw.slice(pos);
    emit(raw);
  };
  const paste = (e) => {
    e.preventDefault();
    emit(normPaste(e.clipboardData.getData("text")));
  };
  return <Input {...props} type="text" inputMode="decimal" value={show(value)} onChange={handle} onPaste={paste} />;
};
